import { render } from "./SalesByCountry.vue?vue&type=template&id=521b4062&scoped=true&ts=true"
import script from "./SalesByCountry.vue?vue&type=script&lang=ts"
export * from "./SalesByCountry.vue?vue&type=script&lang=ts"

import "./SalesByCountry.vue?vue&type=style&index=0&id=521b4062&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521b4062"]])

export default __exports__